// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Card_wrapper_3F-21","active":"Card_active_2e3uW"};